import { render, staticRenderFns } from "./AccountManagement.vue?vue&type=template&id=83cfd926&scoped=true"
import script from "./AccountManagement.vue?vue&type=script&lang=js"
export * from "./AccountManagement.vue?vue&type=script&lang=js"
import style0 from "./AccountManagement.vue?vue&type=style&index=0&id=83cfd926&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83cfd926",
  null
  
)

export default component.exports